// test1491
(1491 && 0);
